import React, { Component } from 'react';
import { Tooltip } from 'reactstrap';
import App_data from '../../config/App_data';
export default class TooltipItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tooltipOpen: false,
    };
  }
  isTooltipToggle = async () => {
    this.setState({ tooltipOpen: !this.state.tooltipOpen });
  };
  render() {
    const { tooltipOpen } = this.state;
    const { content, place_tip, tooltipId } = this.props;
    return (
      <span>
        <img
          src={App_data.frontend_url + '/img/dashboard/info_icon.svg'}
          id={'Tooltip-' + tooltipId}
          alt=''
          width='18'
        />
        <Tooltip
          placement={place_tip}
          isOpen={tooltipOpen}
          target={'Tooltip-' + tooltipId}
          toggle={this.isTooltipToggle}
        >
          <p className='tooltip_text'>{content}</p>
        </Tooltip>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/ESG/Dashboard/Tooltip.jsx